module.exports = __webpack_public_path__ + "img/19_54.9f13c6ff.png";